import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  types: [],
  repetitionsTypes: [],
  monthlyRepetitionTypes: [],
  dutyValueSources: [],
  searchResults: {}
}

export default {
  state,
  actions,
  getters,
  mutations,
}
